import React, { useEffect, useRef } from 'react';
import './Numbers.css';

const Numbers = () => {
    const numbersRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    const numbers = numbersRef.current.querySelectorAll('.numbers-value');
                    numbers.forEach((number) => animateCount(number));
                }
            },
            { threshold: 0.5 } // Trigger when 50% of the section is visible
        );

        observer.observe(numbersRef.current);

        return () => {
            if (numbersRef.current) observer.unobserve(numbersRef.current);
        };
    }, []);

    const animateCount = (element) => {
        const target = +element.getAttribute('data-target');
        const duration = 2000; // Animation duration in milliseconds
        const increment = target / (duration / 16); // Estimate based on 60 FPS
        let current = 0;

        const updateCount = () => {
            current += increment;
            if (current >= target) {
                element.textContent = target;
            } else {
                element.textContent = Math.floor(current);
                requestAnimationFrame(updateCount);
            }
        };

        updateCount();
    };

    return (
        <section className="numbers-section">
            <div className="numbers-container" ref={numbersRef}>
                <div className="numbers-header">
                    <h2 className="numbers-title">We let facts do the talking</h2>
                    <p className="numbers-subtitle">
                    Tailored services for each content creator, no matter the size of your audience.
Book a free first call and learn about our work and secret strategies.

                    </p>
                </div>

                <div className="numbers-grid">
                    <div className="numbers-item">
                        <h3 className="numbers-value gradient-text" data-target="3">0</h3>
                        <p className="numbers-label">Months </p>
                        <p className="numbers-description">To achieve 100% growth</p>
                    </div>

                    <div className="numbers-item">
                        <h3 className="numbers-value gradient-text" data-target="55">0</h3>
                        <p className="numbers-label">Viral Videos Uploaded</p>
                        <p className="numbers-description">In last 90 days</p>
                    </div>

                    <div className="numbers-item">
                        <h3 className="numbers-value gradient-text" data-target="15">0</h3>
                        <p className="numbers-label">Happy Clients</p>
                        <p className="numbers-description">Who wish found us earlier</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Numbers;
